<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 2L3 2L3 22L21 22L21 7L16 2Z" stroke="currentColor" stroke-width="1.5" />
    <path d="M15.5 12.5001L12.0002 16L8.5 12.5" stroke="currentColor" stroke-width="1.5" />
    <path d="M12 16L12 8" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>
